import { useAuth } from '@clerk/clerk-react';
import { TFLoadingOverlay } from '@tf/ui';
import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface Props {
	startPagePath: string;
}

export const NonAuthenticatedRoutesGuard: React.FC<Props> = ({ startPagePath }) => {
	const { isSignedIn } = useAuth();

	if (isSignedIn === undefined) {
		return <TFLoadingOverlay />;
	}

	if (isSignedIn) {
		return <Navigate to={startPagePath} />;
	}

	return <Outlet />;
};
